export class StyleObject {
    public button? = {};
    public date? = {};
    public input? = {};
}
